var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWearable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 15.8334C13.223 15.8334 15.8346 13.2217 15.8346 10.0001C15.8346 6.77842 13.223 4.16675 10.0013 4.16675C6.77964 4.16675 4.16797 6.77842 4.16797 10.0001C4.16797 13.2217 6.77964 15.8334 10.0013 15.8334Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V10L11.25 11.25",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7594 14.4583L13.4677 17.6499C13.4302 18.0655 13.2381 18.4518 12.9295 18.7326C12.621 19.0134 12.2183 19.1683 11.801 19.1666H8.19271C7.77548 19.1683 7.3728 19.0134 7.06421 18.7326C6.75563 18.4518 6.56359 18.0655 6.52604 17.6499L6.23438 14.4583M6.24271 5.5416L6.53438 2.34993C6.5718 1.93583 6.76265 1.55067 7.06947 1.27006C7.37629 0.98945 7.77692 0.833657 8.19271 0.833266H11.8177C12.2349 0.831573 12.6376 0.986431 12.9462 1.26724C13.2548 1.54806 13.4468 1.9344 13.4844 2.34993L13.776 5.5416",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWearable);
export default __webpack_public_path__ + "static/media/wearable.288e4c204e837b939fbeb10af98003e6.svg";
export { ForwardRef as ReactComponent };